<template>
  <div class="match-block">
    <font-awesome-icon
      :icon="['fas','triangle']"
      :title="title"/>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faTriangle } from '@fortawesome/pro-solid-svg-icons';

library.add(faTriangle);

export default {
  props:{
    title: {
      type: String,
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "@/sass/custom.sass"

  .fa-triangle
    color: $success
</style>
